import React from "react";
import PropTypes from "prop-types";
import { Box, Grid, Popover, TextField, Typography, Button } from "@mui/material";
import { StyledButton, inputStyle } from "components/StyledComponents/styledComponents";

const LoanPopover = ({ data, anchorEl, onClose }) => {
  const open = Boolean(anchorEl);
  const MInput = inputStyle();

  const fieldsToShow = {
    "Date ": "date",
    "Disbursed Amount": "disbursedAmount",
    "Application Number": "applicationNumber",
    "Customer Name": "customerName",
    "DSA Name": "dsaName",
    "Connector Name": "connectorName",
    "Gross Payout Percent": "grossPayoutPercent",
    "Revenue ": "grossPayoutAmount",
    "Revenue After TDS": "finalGrossPayoutAmount",
    "DSA Payout%": "dsaPayoutPercent",
    "DSA Revenue": "dsaPayoutAmount",
    "DSA Revenue After TDS": "finalDSAGrossPayoutAmount",
    "Connector Payout%": "subDSAPayoutPercent",
    "Connector Revenue": "subDSAPaymentAmount",
    "Gross TDS": "tdsAmount",
    "Amount Paid": "amountPaid",
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          backgroundColor: "#ffffff",
          width: "90%",
          maxHeight: "90vh",
          overflowY: "auto",
          p: 2,
          outline: "4px solid #fe0094",
          outlineOffset: "-4px",
          borderRadius: "12px",
          //   backgroundImage: "linear-gradient(135deg, rgb(24, 46, 84), #fe0094)",
          backgroundClip: "padding-box",
        },
      }}
    >
      <Box>
        <Typography variant="h6" gutterBottom>
          Loan Details
        </Typography>
        <Grid container spacing={1}>
          {Object.entries(fieldsToShow).map(([label, field]) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={field}>
              <TextField
                label={label}
                value={data[field] || ""}
                fullWidth
                margin="dense"
                InputProps={{ readOnly: true }}
                variant="outlined"
                sx={MInput.b}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    color: MInput.a,
                  },
                }}
              />
            </Grid>
          ))}
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, mr: 2 }}>
          <StyledButton onClick={onClose} variant="contained">
            Close
          </StyledButton>
        </Box>
      </Box>
    </Popover>
  );
};

LoanPopover.propTypes = {
  data: PropTypes.shape({
    date: PropTypes.string,
    disbursedAmount: PropTypes.number,
    applicationNumber: PropTypes.string,
    customerName: PropTypes.string,
    dsaName: PropTypes.string,
    connectorName: PropTypes.string,
    grossPayoutPercent: PropTypes.number,
    grossPayoutAmount: PropTypes.number,
    finalGrossPayoutAmount: PropTypes.number,
    dsaPayoutPercent: PropTypes.number,
    dsaPayoutAmount: PropTypes.number,
    finalDSAGrossPayoutAmount: PropTypes.number,
    subDSAPayoutPercent: PropTypes.number,
    subDSAPaymentAmount: PropTypes.number,
    tdsAmount: PropTypes.number,
    amountPaid: PropTypes.number,
  }).isRequired,
  anchorEl: PropTypes.any, // Accepts any DOM element
  onClose: PropTypes.func.isRequired,
};

export default LoanPopover;
